function configure(Highcharts) {
    Highcharts.wrap(Highcharts.Axis.prototype, "getOffset", function (proceed) {
        proceed.call(this);
        var axis = this, optsTitle = axis.options.title;
        if ((axis.side === 3 || axis.side === 1) && axis.showAxis && axis.axisTitle && optsTitle.align === "high" && optsTitle.y < 0) {
            var bbox = axis.axisTitle.getBBox();
            // +10 margin auto added, but we don't need anymore on the left/right side
            axis.chart.axisOffset[axis.side] -= bbox.width + 10;
            // remove added spacing from top, only once when using multiple axis.
            if (!axis.chart.axisMarginFix) {
                axis.chart.axisMarginFix = true;
                // +10 margin added when the axis offset is greater than zero
                axis.chart.axisOffset[0] += (-optsTitle.y) + bbox.height - 10;
            }
        }
    });
    Highcharts.wrap(Highcharts.Chart.prototype, "resetMargins", function (proceed) {
        proceed.call(this);
        this.axisMarginFix = false;
    });
    /**
     * Adds required parameters to title configuration to display it horizontally.
     *
     * Example
     *  new Highcharts.Chart({ yAxis: { title: Highcharts.toHorizontal({ text: "TitleText" }) } });
     */
    Highcharts.toHorizontal = function (title, opposite) {
        title = title || {};
        title.rotation = 0;
        title.x = opposite ? -10 : 10;
        title.y = -12;
        title.align = "high";
        title.textAlign = opposite ? "right" : "left";
        return title;
    };
}
export default configure;
